module.exports = __webpack_public_path__ + "img/EE.6449cd0d.svg";